import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Grid,
  Image,
} from "@chakra-ui/react";

const MobileCoCreationSection = ({
  blueTitle,
  blackTitle,
  subtitle,
  processes,
  illustrationImage,
  footerText
}) => {
  return (
    <Box w="full" py={12} >
      <Container maxW="7xl">
        <VStack spacing={8}>
          {/* Title and Subtitle */}
          <VStack spacing={4} textAlign="center">
            <Heading
              as="h1"
              fontSize={{ base: "2xl", md: "4xl" }}
              fontWeight="bold"
              color="#000B8C"
              lineHeight="1.2"
            >
              {blueTitle}{" "}
              <Text as="span" color="gray.700">
                {blackTitle}
              </Text>
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              color="gray.600"
              maxW="4xl"
              textAlign="center"
            >
              {subtitle}
            </Text>
          </VStack>

          {/* Main Content Grid */}
          <Grid
            templateColumns={{ base: "1fr", lg: "1fr 1fr" }}
            gap={12}
            alignItems="center"
            w="full"
          >
            {/* Left Content - Illustration */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              order={{ base: 2, lg: 1 }}
            >
              <Image
                src={illustrationImage}
                alt="Co-Creation Illustration"
                maxW="100%"
                h="auto"
                objectFit="contain"
              />
            </Box>

            {/* Right Content - Process List */}
            <VStack spacing={4} align="start" order={{ base: 1, lg: 2 }}>
              {processes.map((process) => (
                <Box
                  key={process.id}
                  bg="white"
                  p={4}
                  borderRadius="lg"
                  border="1px"
                  borderColor="gray.200"
                  w="full"
                  shadow="sm"
                  transition="all 0.3s ease"
                  _hover={{
                    shadow: "md",
                    borderColor: "blue.200",
                  }}
                >
                  <HStack spacing={3} align="start">
                    <Image
                      src={process.icon}
                      w={8}
                      h={8}
                      className="service-icon"
                      transition="all 0.3s ease"
                    />

                    <Text
                      fontWeight="normal"
                      color="#000B8C"
                      fontSize="md"
                      lineHeight="1.5"
                    >
                      {process.title}
                    </Text>
                  </HStack>
                </Box>
              ))}
            </VStack>
          </Grid>

          {/* Footer Text */}
          <Text
            fontSize={{ base: "sm", md: "md" }}
            color="gray.600"
            textAlign="center"
            fontStyle="italic"
            maxW="4xl"
          >
            {footerText}
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default MobileCoCreationSection;